import React from 'react';
import { Card, Descriptions, Skeleton, Typography } from 'antd';
import {
    formatSourceDate,
    getMigrationReadiness,
    getMigrationMethod,
    formatTags,
    getOSDescription,
    getPowerState,
    cloudSizing,
} from '../utils.jsx';

const { Text } = Typography;

const SourceInformation = React.memo(({ source, isFetching }) => {
    if (!source) return null;

    if (isFetching) {
        return (
            <Card title="Source Information" size="small">
                <Skeleton active />
            </Card>
        );
    }

    return (
        <Card title="Source Information" size="small">
            <Descriptions column={1} size="small">
                <Descriptions.Item label="ID">
                    <Text copyable>{source.id}</Text>
                </Descriptions.Item>
                <Descriptions.Item label="Host/IP">
                    <Text copyable>{source.host}</Text>
                </Descriptions.Item>
                <Descriptions.Item label="Host Name">
                    <Text copyable={!!source.hostname}>{source.hostname}</Text>
                </Descriptions.Item>
                <Descriptions.Item label="Migration Method">{getMigrationMethod(source)}</Descriptions.Item>
                <Descriptions.Item label="OS">{getOSDescription(source)}</Descriptions.Item>
                <Descriptions.Item label="Created">{formatSourceDate(source.created_at)}</Descriptions.Item>
                <Descriptions.Item label="Last Inspected">
                    {formatSourceDate(source.last_inspected_at)}
                </Descriptions.Item>
                <Descriptions.Item label="Migration Readiness">{getMigrationReadiness(source)}</Descriptions.Item>
                <Descriptions.Item label="Power State">{getPowerState(source)}</Descriptions.Item>
                <Descriptions.Item label="Cloud Sizing">{cloudSizing(source)}</Descriptions.Item>
                <Descriptions.Item label="Tags">{formatTags(source.tags)}</Descriptions.Item>
            </Descriptions>
        </Card>
    );
});

export default SourceInformation;
